// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
// import './common/js/font'
import 'lib-flexible'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import clipboard from 'clipboard'; //复制
//注册到vue原型上
Vue.prototype.clipboard = clipboard;

import AgoraRTC from "agora-rtc-sdk-ng"
Vue.prototype.$AgoraRTC=AgoraRTC;



import './common/style/common.css'
import 'fullpage.js/vendors/scrolloverflow'; // 全屏滚动插件
import VueFullPage from 'vue-fullpage.js';
// ...
import { QNRTPlayer } from "qn-rtplayer-web";
Vue.prototype.$player = new QNRTPlayer();
Vue.use(VueFullPage);




import axios from 'axios';
import api   from './api/api_config'
Vue.prototype.$api=api;
Vue.prototype.$http=axios;
Vue.config.productionTip = false

Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'userinfo') {

      // 创建一个StorageEvent事件
      var newStorageEvent = document.createEvent('StorageEvent');
      const storage = {
          setItem: function (k, val) {
            localStorage.setItem(k, val);

              // 初始化创建的事件
              newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);

              // 派发对象
              window.dispatchEvent(newStorageEvent)
          }
      }
      return storage.setItem(key, newVal);
  }
}




/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js